module.exports = __webpack_public_path__ + "static/media/aoe-triangle-3-with-corner-black.1f34cc03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/lib/monsters/aoe-triangle-3-with-corner-black.svg
// module id = 63
// module chunks = 0